import {FETCH_ONE_COUPON, CLEAR_ONE_COUPON} from 'constants/ActionTypes';

const INIT_STATE = [];

export default (state = INIT_STATE , action) => {
    switch(action.type) {
        case FETCH_ONE_COUPON : {
            if (action.payload == undefined) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } case CLEAR_ONE_COUPON :{
            const clearState = [];
            return clearState;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/appRedux/reducers/OneCoupon.js